import React, { useState } from "react";
import { getMovies, sortByDateDesc } from "../../data/movies";
import "./movies.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getShortMovies } from "../../data/short_movies";


export const LOCAL_STORAGE_AUTH_TOKEN_SET = 'authTokenSet';

export default function Movies() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  let selectedLink = "";

  function checkIfAuthNeeded(link: string) {
    selectedLink = link;
    const modalOpenButton = document.getElementById("modalOpenButton");
    const stored = localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN_SET);
    const dateOfLastAuth = stored ? Number.parseInt(stored) : null;
    const oneDay = 24 * 60 * 60 * 1000;
    const now = Date.now();

    if (dateOfLastAuth && (now - dateOfLastAuth) < oneDay) {
      window.open(link, "_self");
    } else {
      modalOpenButton.click();
      setStatus("");
    }
  }

  function checkPassword(e) {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);
    try {
      fetch('/api/check-auth', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: formData.get('password')
      }).then(async (result) => {
        const responseData = await result.json();
        const { authorized } = responseData;
        if (authorized) {
          localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN_SET, Date.now().toString());
          window.open(selectedLink, "_self");
        } else {
          setStatus("error");
        }
        e.target.reset();
        setLoading(false);
      });
    } catch (e) {
      console.error('Network error submitting form:', e)
      setLoading(false);
    }
  }

  return (
    <div className="app-body flex-grow-1 bg-light-gradient">
      <div className="container">
        <h1 className="m-3">{t("movies.filmography")}</h1>
        <div className="d-flex flex-row flex-wrap align-items-center p-0">
          {
            getMovies(true, false).sort(sortByDateDesc()).map((currentMovie) => {
              return (
                <div className="col-12 col-md-6 col-xl-4 col-xxl-3 p-3" key={currentMovie.id}>
                  {
                    currentMovie.requiresAuth && (
                      <div className="position-relative hover-zoom d-block bg-light rounded-3 overflow-hidden">
                        <div
                          className="position-absolute bottom-0 end-0 translate-middle bg-primary d-flex align-items-center justify-content-center rounded-3">
                          <i className="bi bi-lock d-block"/>
                        </div>
                        <img src={"/assets/" + currentMovie.cover}
                             className="w-100 bg-light text-black"
                             alt={currentMovie.name}
                             onClick={() => {
                               checkIfAuthNeeded(`/movies/${currentMovie.id}`);
                             }}/>
                        <button data-bs-toggle="modal" data-bs-target="#passwordModal" id="modalOpenButton"
                                className="visually-hidden"></button>
                      </div>
                    )
                  }
                  {
                    !currentMovie.requiresAuth && (
                      <Link className="hover-zoom d-block bg-light rounded-3 overflow-hidden"
                            to={`/movies/${currentMovie.id}`}>
                        <img src={"/assets/" + currentMovie.cover} className="w-100 text-black"
                             alt={currentMovie.name}/>
                      </Link>
                    )
                  }
                </div>
              );
            })
          }
        </div>
      </div>
      <div className="container short-movies">
        <h1 className="m-3">{t("movies.short_movies")}</h1>
        <div className="d-flex flex-row flex-wrap align-items-center p-0">
          {
            getShortMovies().sort(sortByDateDesc()).map((currentMovie) => {
              return (
                <div className="col-12 col-xl-6 p-3" key={currentMovie.id}>
                  <iframe
                    className="w-100 rounded-3 bg-light"
                    src={currentMovie.links.movie}
                    title={currentMovie.name}
                    allow="clipboard-write;
                          encrypted-media;
                          gyroscope;
                          picture-in-picture;
                          web-share"
                    allowFullScreen></iframe>
                </div>
              );
            })
          }
        </div>
      </div>

      <div className="modal fade" id="passwordModal" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-light">
              <div className="d-flex justify-content-between align-items-start">
                <p className="fs-6">{t("movies.limited_access_modal.text")}</p>
                <button type="button" className="btn-close btn-close-white m-0 p-2" data-bs-dismiss="modal"
                        aria-label="Close" disabled={loading}></button>
              </div>
              <form onSubmit={checkPassword}>
                <div className="my-2">
                  <label htmlFor="password" className="col-form-label">{t("movies.limited_access_modal.label")}</label>
                  <input type="password" className="form-control text-light" id="password" name="password"
                         disabled={loading}/>
                </div>
                <div hidden={status !== 'error'} className="w-100 m-0 text-danger">
                  <p className="m-0 fs-6">{t("movies.limited_access_modal.error")}</p>
                </div>
                <div className="d-flex justify-content-end">
                  <button type="submit"
                          className="btn btn-primary px-4 d-flex align-items-center justify-content-center"
                          disabled={loading}>
                    <div hidden={!loading} className="loader loader-button me-2"></div>
                    {t("movies.limited_access_modal.submit")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}